import { getStoreId } from '@utils/EnvironmentUtil'
import { LatencyMetric, VoiceException } from '@amzn/ihm-associate-tools-js-lib'
import axios from 'axios'
import * as AudioPlayer from '../utils/AudioPlayer'
import listeningStart from '../media/listening-start.wav'
import listeningEnd from '../media/listening-end.wav'

const VoiceAudioCuesServiceConstants = {
    START_CUE_SOUND_SOURCE: listeningStart,
    END_CUE_SOUND_SOURCE: listeningEnd,
}

const urlCache = {}

export const warmup = () => {
    return Promise.all([
        getObjectUrl(VoiceAudioCuesServiceConstants.START_CUE_SOUND_SOURCE),
        getObjectUrl(VoiceAudioCuesServiceConstants.END_CUE_SOUND_SOURCE),
    ])
    .catch((e) => {
        console.warn('voiceAudioCuesService.warmup: Error warming up')
        return Promise.reject(new VoiceException({
            message: 'Error warming up voiceAudioCuesService',
        }))
    })
}

/**
 * Plays audio cue for recording start.
 *
 * @return {Promise} Resolves when the audio cue is done playing
 */
export const playListeningStart = () => {
    return playSound(VoiceAudioCuesServiceConstants.START_CUE_SOUND_SOURCE, 'voiceAudioCuesService.playListeningStart')
}

/**
 * Plays audio cue for recording end.
 *
 * @return {Promise} Resolves when the audio cue is done playing
 */
export const playListeningEnd = () => {
    return playSound(VoiceAudioCuesServiceConstants.END_CUE_SOUND_SOURCE, 'voiceAudioCuesService.playListeningEnd')
}

/**
 * Plays audio cue with the appropriate priority.
 *
 * @return {Promise} Resolves when the audio cue is done playing
 */
const playSound = (soundSource, metricMethod) => {
    const latencyMetric = new LatencyMetric(getStoreId(), 'Time', 'IhmFlyingDutchman', metricMethod)
    latencyMetric.start()

    return getObjectUrl(soundSource)
        .then((objectUrl) => {
            console.info('voiceAudioCuesService.playSound: Playing', objectUrl, soundSource)
            return AudioPlayer.playSoundBySource(objectUrl, {
                priority: AudioPlayer.AudioPriority.VOICE_AUDIO_CUE,
            })
        })
        .then(() => {
            latencyMetric.stop()
            console.debug('voiceAudioCuesService.playSound: Done playing', soundSource)
        })
}

const getObjectUrl = (source) => {
    if (urlCache[source]) {
        console.info('voiceAudioCuesService.getObjectUrl: Url was already cached', source)
        return urlCache[source]
    }

    urlCache[source] = axios({
        url: source,
        method: 'GET',
        responseType: 'arraybuffer',
    })
    .then((response) => {
        console.info('voiceAudioCuesService.getObjectUrl: Creating URL for', source)
        const blob = new window.Blob([response.data])
        return window.URL.createObjectURL(blob)
    })
    .catch((response) => {
        console.error('voiceAudioCuesService.getObjectUrl: Could not get file', source, 'response', response)
        delete urlCache[source]
        return Promise.reject(new VoiceException({
            message: 'Error retrieving file ' + source,
        }))
    })

    return urlCache[source]
}
